/** Frontmatter for the "preseason-week-2-recap" article; the Body lives in preseason-week-2-recap.jsx. */
const meta = {
  slug: 'preseason-week-2-recap',
  title: 'NFL Preseason Week 2 Recap: Draft Stock, Rookie Breakouts, and Injury Fallout',
  category: 'Recap',
  author: 'Andy Darkness',
  excerpt:
    'A source-backed fantasy stock watch from all 16 NFL preseason Week 2 games, including rookie standouts, defensive disruptors, and the injuries reshaping draft decisions.',
  readMinutes: 14,
  date: '2026-08-24',
};

export default meta;
